export const LOAD_DOCUMENT_PARTNER_RELATIONS_SUCCEEDED = "LOAD_DOCUMENT_PARTNER_RELATIONS_SUCCEEDED";
export const LOAD_PARTNER_RELATION_TYPES_SUCCEEDED = "LOAD_PARTNER_RELATION_TYPES_SUCCEEDED";
export const SAVE_DOCUMENT_PARTNER_RELATION_STARTED = "SAVE_DOCUMENT_PARTNER_RELATION_STARTED";
export const SAVE_DOCUMENT_PARTNER_RELATION_SUCCEEDED = "SAVE_DOCUMENT_PARTNER_RELATION_SUCCEEDED";
export const SAVE_DOCUMENT_PARTNER_RELATION_FAILED = "SAVE_DOCUMENT_PARTNER_RELATION_FAILED";
